var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2469_1268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F8153B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2469_1268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 23C14.0833 23 13.7291 22.8542 13.4375 22.5625C13.1458 22.2708 13 21.9167 13 21.5V14.5C13 14.0833 13.1458 13.7292 13.4375 13.4375C13.7291 13.1458 14.0833 13 14.5 13H21.5C21.9166 13 22.2708 13.1458 22.5625 13.4375C22.8541 13.7292 23 14.0833 23 14.5V21.5C23 21.9167 22.8541 22.2708 22.5625 22.5625C22.2708 22.8542 21.9166 23 21.5 23H14.5ZM9.24995 22L8.84995 18.8C8.63329 18.7167 8.42912 18.6167 8.23745 18.5C8.04578 18.3833 7.85828 18.2583 7.67495 18.125L4.69995 19.375L1.94995 14.625L4.52495 12.675C4.50828 12.5583 4.49995 12.4458 4.49995 12.3375V11.6625C4.49995 11.5542 4.50828 11.4417 4.52495 11.325L1.94995 9.375L4.69995 4.625L7.67495 5.875C7.85828 5.74167 8.04995 5.61667 8.24995 5.5C8.44995 5.38333 8.64995 5.28333 8.84995 5.2L9.24995 2H14.75L15.15 5.2C15.3666 5.28333 15.5708 5.38333 15.7625 5.5C15.9541 5.61667 16.1416 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.925 11H15.4C15.1666 10.2833 14.75 9.6875 14.15 9.2125C13.55 8.7375 12.85 8.5 12.05 8.5C11.0833 8.5 10.2583 8.84167 9.57495 9.525C8.89162 10.2083 8.54995 11.0333 8.54995 12C8.54995 12.8 8.77495 13.5 9.22495 14.1C9.67495 14.7 10.2666 15.1167 11 15.35V22H9.24995ZM15 21H21V20.175C20.5833 19.7917 20.1166 19.5 19.6 19.3C19.0833 19.1 18.55 19 18 19C17.45 19 16.9166 19.1 16.4 19.3C15.8833 19.5 15.4166 19.7917 15 20.175V21ZM18 18C18.4166 18 18.7708 17.8542 19.0625 17.5625C19.3541 17.2708 19.5 16.9167 19.5 16.5C19.5 16.0833 19.3541 15.7292 19.0625 15.4375C18.7708 15.1458 18.4166 15 18 15C17.5833 15 17.2291 15.1458 16.9375 15.4375C16.6458 15.7292 16.5 16.0833 16.5 16.5C16.5 16.9167 16.6458 17.2708 16.9375 17.5625C17.2291 17.8542 17.5833 18 18 18Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentSettings);
export default __webpack_public_path__ + "static/media/AgentSettings.00519bdeec7e3f029d099ae6e89814d0.svg";
export { ForwardRef as ReactComponent };